import DefaultContentButtons from '@/modules/content/editor/Buttons';

/**
 * Configuración de componentes que se listarán en el botón de opciones avanzadas del editor de contenido.
 * Deben configurarse siguiendo el siguiente formato a nivel site:
 * toolsComponentConfig.listTilesTools =[
 {
    title: 'Estadísticas',
    icon: 'equalizer',
    component: DemoStatsTool,
    contentTypes: ['news'],
  }
 ];
 * OJO: A nivel de plantilla, componente 'component' debería ser un v- <v-list-tile> válido:
 * @type {{listTilesTools: Array}}
 */
export const toolsComponentConfig = {
  listTilesTools: [],
};

/**
 * Configuración de tipos de contenido transcodificables para los que hay que mostrar una cabecera de estados diferente
 * @type {string[]}
 */
export const transcodificableContents = ['video'];

export const siteChips = {
  component: {},
};

export const buttonsConfig = {
  component: DefaultContentButtons,
};

export default {
  toolsComponentConfig,
  transcodificableContents,
  siteChips,
  buttonsConfig,
};
